import { render, staticRenderFns } from "./Peers.vue?vue&type=template&id=943ae2b6&scoped=true"
import script from "./Peers.vue?vue&type=script&lang=js"
export * from "./Peers.vue?vue&type=script&lang=js"
import style0 from "./Peers.vue?vue&type=style&index=0&id=943ae2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943ae2b6",
  null
  
)

export default component.exports